import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientLicenseEntity } from './client-license.entity';
import { FileEntity } from './file.entity';

@Index('license__file__fk_file__id_fk', ['fkFileId'], {})
@Index('license__file__fk_license__id_fk', ['fkLicenseId'], {})
@Entity('license__file')
export class LicenseFileEntity extends BaseEntity {
	@Column('int', { name: '_fk_file__id', unsigned: true })
	public fkFileId!: number;

	@Column('int', { name: '_fk_license__id', unsigned: true })
	public fkLicenseId!: number;

	@ManyToOne(() => ClientLicenseEntity, (license) => license.licenseFiles, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_license__id', referencedColumnName: 'id' }])
	public fkLicense!: ClientLicenseEntity;

	@ManyToOne(() => FileEntity, (file) => file.licenseFiles, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_file__id', referencedColumnName: 'id' }])
	public fkFile!: FileEntity;
}
